import React from 'react';
import { Box, Button, Container, Typography, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const ContactThankYou: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h3" component="h1" sx={{ color: '#003366', fontWeight: 800, mb: 2 }}>
        Thank You
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 4 }}>
        Your inquiry has been submitted. Our team will reach out shortly.
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
        <Button component={RouterLink} to="/" variant="outlined" sx={{ borderColor: '#003366', color: '#003366' }}>
          Back to Home
        </Button>
        <Button component={RouterLink} to="/docs" variant="outlined" sx={{ borderColor: '#003366', color: '#003366' }}>
          View Documentation
        </Button>
        <Button component={RouterLink} to="/admin/contact-inquiries" variant="contained" sx={{ backgroundColor: '#003366', '&:hover': { backgroundColor: '#00264d' } }}>
          Admin: Contact Inquiries
        </Button>
      </Stack>

      <Box sx={{ mt: 6 }}>
        <Typography variant="caption" color="text.secondary">
          If you need immediate assistance, email contact@e-unify.ai.
        </Typography>
      </Box>
    </Container>
  );
};

export default ContactThankYou;
